import { makeRequest } from '@/shared/services/http';
import { getAddressPredictions, getAddressDetails } from './address';
import { IPharmacy } from '../types/interfaces/pharmacy';
import { formatPharmaciesList } from '../../modules/onboarding/pages/medbox/helpers';
import { localPharmacyNPIs } from '@/shared/constants/main';

export const loadPharmacies = async (
    query: string,
    existingPharmaciesListInUse: IPharmacy[],
    zip: string = '',
    signal: AbortSignal
): Promise<IPharmacy[]> => {
    if (query.length < 2) return [];
    try {
        const pharmacies = await makeRequest<IPharmacy[]>('get', 'pharmacies', 'search', { params: { term: query, zip }, signal });

        if (!pharmacies?.length) {
            const addressPredictions = await getAddressPredictions(query);
            if (addressPredictions?.length) {
                const addressFetchesFromPrediction = [];

                for (const prediction of addressPredictions) {
                    addressFetchesFromPrediction.push(getAddressDetails(prediction.place_id));
                }
                const addressesFetchedViaPlaceIdsFromPredictionResults = await Promise.all(addressFetchesFromPrediction);
                const pharmacyPromises = addressesFetchedViaPlaceIdsFromPredictionResults
                    .filter(
                        (curAddress, index, self) =>
                            !!curAddress && index === self.findIndex(address => address?.formatted_address === curAddress.formatted_address)
                    )
                    .map(address =>
                        makeRequest<IPharmacy[]>('get', 'pharmacies', 'search', { params: { term: address?.formatted_address } })
                    );
                const pharmacies = await Promise.all(pharmacyPromises);
                return formatPharmaciesList(pharmacies.flat())
                    .filter(
                        (pharmacy, index, self) => index === self.findIndex(p => p.npi === pharmacy.npi) // if we find a duplicate, i.e its index is not the same as the current index, we filter it out
                    )
                    .filter(item => !existingPharmaciesListInUse.find(prov => prov.npi === item.npi));
            }
            return [];
        }

        return formatPharmaciesList(pharmacies).filter(item => {
            return !existingPharmaciesListInUse.find(prov => prov.npi === item.npi) && !localPharmacyNPIs.includes(item.npi);
        });
    } catch (e) {
        console.error(e);
        return [];
    }
};
